import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { ReadMoreComponent } from './read-more/read-more.component';
import { SendNotificationBtnComponent } from './send-notification-btn/send-notification-btn.component';
import { SortableLabelComponent } from './sortable-label/sortable-label.component';
import { ToggleLabelDirective } from './toggle-label/toggle-label.directive';

import { BreadcrumbComponent } from 'src/app/modules/shared/breadcrumb/breadcrumb.component';
import { ComingSoonComponent } from 'src/app/modules/shared/coming-soon/coming-soon.component';
import { HeaderComponent } from 'src/app/modules/shared/header/header.component';
import { InfoDialogComponent } from 'src/app/modules/shared/info-dialog/info-dialog.component';
import { NoticeComponent } from 'src/app/modules/shared/notice/notice.component';
import {
  PageIndicatorComponent,
} from 'src/app/modules/shared/page-indicator/page-indicator.component';
import {
  PaginationStripComponent,
} from 'src/app/modules/shared/pagination-strip/pagination-strip.component';
import {
  PayoutCommissionValueComponent,
} from 'src/app/modules/shared/payout-commission-value/payout-commission-value.component';
import { SidebarComponent } from 'src/app/modules/shared/sidebar/sidebar.component';
import {
  TimeZoneMessageComponent,
} from 'src/app/modules/shared/timezone-message/timezone-message.component';

import { NgxPermissionsModule } from 'ngx-permissions';
import { HeaderV2Component } from 'src/app/modules/shared//header-v2/header-v2.component';
import { FooterV2Component } from 'src/app/modules/shared//footer-v2/footer-v2.component';
import { PollingLoadingMessageComponent } from 'src/app/shared/polling-loading-message/polling-loading-message.component';

@NgModule({
  declarations: [
    HeaderComponent,
    InfoDialogComponent,
    SidebarComponent,
    ComingSoonComponent,
    BreadcrumbComponent,
    ReadMoreComponent,
    PageIndicatorComponent,
    PaginationStripComponent,
    PayoutCommissionValueComponent,
    SortableLabelComponent,
    ConfirmDialogComponent,
    TimeZoneMessageComponent,
    NoticeComponent,
    ToggleLabelDirective,
    SendNotificationBtnComponent,
    HeaderV2Component,
    FooterV2Component,
    PollingLoadingMessageComponent
  ],
  imports: [
    CommonModule,
    NgbModule,
    RouterModule,
    NgxPermissionsModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports: [
    HeaderComponent,
    InfoDialogComponent,
    SidebarComponent,
    ComingSoonComponent,
    BreadcrumbComponent,
    RouterModule,
    ReadMoreComponent,
    PageIndicatorComponent,
    PaginationStripComponent,
    PayoutCommissionValueComponent,
    SortableLabelComponent,
    TimeZoneMessageComponent,
    NoticeComponent,
    ToggleLabelDirective,
    SendNotificationBtnComponent,
    HeaderV2Component,
    FooterV2Component,
    PollingLoadingMessageComponent
  ],
})
export class SharedModule { }
